import Icons from '../../../components/icons';
import {
  ColumnMappingOption,
  familyTabTypes,
  studentTabTypes,
  TabConfig
} from '../types';

const StudentProfileColumnsOptions: ColumnMappingOption[] = [
  {
    value: 'student__enrollmentNo',
    fieldMatchWithColumn: 'enrollmentNo',
    label: 'Student Enrollment No'
  },
  {
    value: 'student__name',
    fieldMatchWithColumn: 'name',
    label: 'Student Name'
  },
  {
    value: 'student_photo_uploaded',
    fieldMatchWithColumn: 'Student Photo Uploaded?',
    label: 'Student Photo Uploaded?'
  },
  {
    value: 'student__email',
    fieldMatchWithColumn: 'email',
    label: 'Student Email'
  },
  {
    value: 'student__profile',
    fieldMatchWithColumn: 'profile',
    label: 'Student Photo'
  },
  {
    value: 'student__grade',
    fieldMatchWithColumn: 'grade',
    label: 'Grade'
  },
  {
    value: 'student__division',
    fieldMatchWithColumn: 'division',
    label: 'Division'
  },
  {
    value: 'student__rollNo',
    fieldMatchWithColumn: 'rollNo',
    label: 'Roll No'
  },
  {
    value: 'student__house',
    fieldMatchWithColumn: 'house',
    label: 'House'
  },
  {
    value: 'student__gender',
    fieldMatchWithColumn: 'gender',
    label: 'Student Gender'
  },
  {
    value: 'student__status',
    fieldMatchWithColumn: 'status',
    label: 'Student Status'
  },
  {
    value: 'student__type',
    fieldMatchWithColumn: 'studentType',
    label: 'Student Type'
  },
  {
    value: 'student__mobile_no',
    fieldMatchWithColumn: 'personalDetails.contactNo',
    label: 'Communication Number'
  },
  {
    value: 'student__nationality',
    fieldMatchWithColumn: 'personalDetails.nationality',
    label: 'Student Nationality'
  },
  {
    value: 'student__country',
    fieldMatchWithColumn: 'personalDetails.country',
    label: 'Student Country'
  },
  {
    value: 'student__aadhar_card_no',
    fieldMatchWithColumn: 'officialDetails.adhaarCardNo',
    label: 'Student Adhaar Card No'
  },
  {
    value: 'student__residential_address',
    fieldMatchWithColumn: 'personalDetails.residentialAddress',
    label: 'Student Address'
  },
  {
    value: 'student__place_of_birth',
    fieldMatchWithColumn: 'personalDetails.birthPlace',
    label: 'Student Birth Place'
  },
  {
    value: 'student__date_of_birth',
    fieldMatchWithColumn: 'personalDetails.dateOfBirth',
    label: 'Student Date Of Birth'
  },
  {
    value: 'student__religion',
    fieldMatchWithColumn: 'personalDetails.religion',
    label: 'Student Religion'
  },
  {
    value: 'student__caste',
    fieldMatchWithColumn: 'personalDetails.caste',
    label: 'Student Caste'
  },
  {
    value: 'student__mother_tongue',
    fieldMatchWithColumn: 'personalDetails.motherTongue',
    label: 'Student Mother Tongue'
  },
  {
    value: 'student__blood_group',
    fieldMatchWithColumn: 'personalDetails.bloodGroup',
    label: 'Student Blood Group'
  },
  {
    value: 'student__passport_no',
    fieldMatchWithColumn: 'officialDetails.passportNo',
    label: 'Student Passport No'
  },
  {
    value: 'student__passport_expiry_date',
    fieldMatchWithColumn: 'officialDetails.passportExpiryDate',
    label: 'Student Passport Expiry'
  },
  {
    value: 'student__oci_or_visa',
    fieldMatchWithColumn: 'officialDetails.visa',
    label: 'Student Visa'
  },
  {
    value: 'student__emergency_contact_person',
    fieldMatchWithColumn: 'emergencyContactDetails.emergencyContactPersonName',
    label: 'Emergency Contact Person Name'
  },
  {
    value: 'student__emergency_contact_person_relation',
    fieldMatchWithColumn: 'emergencyContactDetails.relationWithStudent',
    label: 'Emergency Contact Person Relation'
  },
  {
    value: 'student__emergency_contact_number',
    fieldMatchWithColumn: 'emergencyContactDetails.emergencyContactNo',
    label: 'Emergency Contact Person Contact No'
  },
  {
    value: 'medical__medication_specification',
    fieldMatchWithColumn: 'studentHealthInfo.medicationDetails',
    label: 'Medications'
  },
  {
    value: 'medical__allergies_specification',
    fieldMatchWithColumn: 'studentHealthInfo.allergyDetails',
    label: 'Allergies'
  },
  {
    value: 'medical__health_concerns',
    fieldMatchWithColumn: 'studentHealthInfo.medicalProblemDetails',
    label: 'Medical Problems'
  },
  {
    value: 'student__medical_practitioner_name',
    fieldMatchWithColumn: 'medicalPractitionerInfo.name',
    label: 'Medical Practitioner Name'
  },
  {
    value: 'student__medical_practitioner_clinic_address',
    fieldMatchWithColumn: 'medicalPractitionerInfo.address',
    label: 'Medical Practitioner Address'
  },
  {
    value: 'student__medical_clinic_phone_no',
    fieldMatchWithColumn: 'medicalPractitionerInfo.clinicPhoneNo',
    label: 'Medical Practitioner Clinic Phone No'
  },
  {
    value: 'student__medical_practitioner_mobile_no',
    fieldMatchWithColumn: 'medicalPractitionerInfo.mobileNo',
    label: 'Medical Practitioner Mobile No'
  },
  {
    value: 'guardian__name',
    fieldMatchWithColumn: 'guardianInfo.name',
    label: 'Guardian Name'
  },
  {
    value: 'guardian_photo_uploaded',
    fieldMatchWithColumn: 'Guardian Photo Uploaded?',
    label: 'Guardian Photo Uploaded?'
  },
  {
    value: 'guardian__relationship_with_student',
    fieldMatchWithColumn: 'guardianInfo.relation',
    label: 'Guardian Relation'
  },
  {
    value: 'guardian__mobile_no',
    fieldMatchWithColumn: 'guardianInfo.personalDetails.contactNo',
    label: 'Guardian Contact No'
  },
  {
    value: 'guardian__email_id',
    fieldMatchWithColumn: 'guardianInfo.emailId',
    label: 'Guardian Email Id'
  },
  {
    value: 'guardian__residential_address',
    fieldMatchWithColumn: 'guardianInfo.personalDetails.residentialAddress',
    label: 'Guardian Address'
  },
  {
    value: 'guardian__aadhar_card_no',
    fieldMatchWithColumn: 'guardianInfo.officialDetails.adhaarCardNo',
    label: 'Guardian Adhaar Card No'
  },
  {
    value: 'guardian__pan_card_no',
    fieldMatchWithColumn: 'guardianInfo.officialDetails.panCardNo',
    label: 'Guardian Pancard No'
  },
  {
    value: 'guardian__educational_qualifications',
    fieldMatchWithColumn: 'guardianInfo.educationalQualification',
    label: 'Guardian Educational Qualification'
  },
  {
    value: 'guardian__profession',
    fieldMatchWithColumn: 'guardianInfo.occupationDetails.profession',
    label: 'Guardian Profession'
  },
  {
    value: 'guardian__name_of_organisation',
    fieldMatchWithColumn: 'guardianInfo.occupationDetails.organizationName',
    label: 'Guardian Organization Name'
  },
  {
    value: 'guardian__designation',
    fieldMatchWithColumn: 'occupationDetails.designation',
    label: 'Guardian Designation'
  },
  {
    value: 'guardian__office_contact_no',
    fieldMatchWithColumn: 'guardianInfo.occupationDetails.officeContactNo',
    label: 'Guardian Office Contact No'
  },
  {
    value: 'guardian__office_address',
    fieldMatchWithColumn: 'guardianInfo.occupationDetails.officeAddress',
    label: 'Guardian Office Address'
  },
  {
    value: 'guardian__website_or_linkedin_profile',
    fieldMatchWithColumn:
      'guardianInfo.occupationDetails.websiteOrLinkedInProfileUrl',
    label: 'Guardian Website'
  },
  {
    value: 'guardian__annual_income',
    fieldMatchWithColumn: 'guardianInfo.occupationDetails.annualIncome',
    label: 'Guardian Annual Income'
  },
  {
    value: 'guardian__is_govt_employee',
    fieldMatchWithColumn: 'guardianInfo.occupationDetails.isGovermentEmployee',
    label: 'Guardian Is Govt Employee?'
  },
  {
    value: 'guardian__name_of_department',
    fieldMatchWithColumn: 'guardianInfo.occupationDetails.department',
    label: 'Guardian Govt Department Name'
  },
  {
    value: 'guardian__profile',
    fieldMatchWithColumn: 'guardianInfo.profile',
    label: 'Guardian Photo'
  }
];

const MotherColumnsOptions: ColumnMappingOption[] = [
  {
    value: 'mother__name',
    fieldMatchWithColumn: 'name',
    label: 'Mother Name'
  },
  {
    value: 'mother_photo_uploaded',
    fieldMatchWithColumn: 'Mother Photo Uploaded?',
    label: 'Mother Photo Uploaded?'
  },
  {
    value: 'mother__profile',
    fieldMatchWithColumn: 'profile',
    label: 'Mother Photo'
  },
  {
    value: 'mother__moblie_no',
    fieldMatchWithColumn: 'personalDetails.contactNo',
    label: 'Mother Contact No'
  },
  {
    value: 'mother__email_id',
    fieldMatchWithColumn: 'email',
    label: 'Mother Email'
  },
  {
    value: 'mother__aadhar_card_no',
    fieldMatchWithColumn: 'officialDetails.adhaarCardNo',
    label: 'Mother Adhaar Card No'
  },
  {
    value: 'mother__pan_card_no',
    fieldMatchWithColumn: 'officialDetails.panCardNo',
    label: 'Mother Pancard No'
  },
  {
    value: 'mother__educational_qualifications',
    fieldMatchWithColumn: 'educationalQualification',
    label: 'Mother Educational Qualification'
  },
  {
    value: 'mother__profession',
    fieldMatchWithColumn: 'occupationDetails.profession',
    label: 'Mother Profession'
  },
  {
    value: 'mother__name_of_organisation',
    fieldMatchWithColumn: 'occupationDetails.organizationName',
    label: 'Mother Organization Name'
  },
  {
    value: 'mother__designation',
    fieldMatchWithColumn: 'occupationDetails.designation',
    label: 'Mother Designation'
  },
  {
    value: 'mother__office_contact_no',
    fieldMatchWithColumn: 'occupationDetails.officeContactNo',
    label: 'Mother Office Contact No'
  },
  {
    value: 'mother__office_address',
    fieldMatchWithColumn: 'occupationDetails.officeAddress',
    label: 'Mother Office Address'
  },
  {
    value: 'mother__website_or_linkedin_profile',
    fieldMatchWithColumn: 'occupationDetails.websiteOrLinkedInProfileUrl',
    label: 'Mother Website'
  },
  {
    value: 'mother__annual_income',
    fieldMatchWithColumn: 'occupationDetails.annualIncome',
    label: 'Mother Annual Income'
  },
  {
    value: 'mother__is_govt_employee',
    fieldMatchWithColumn: 'occupationDetails.isGovermentEmployee',
    label: 'Mother is Govt Employee?'
  },
  {
    value: 'mother__name_of_department',
    fieldMatchWithColumn: 'occupationDetails.department',
    label: 'Mother Govt Department'
  }
];

const FatherColumnsOptions: ColumnMappingOption[] = [
  {
    value: 'father__name',
    fieldMatchWithColumn: 'name',
    label: 'Father Name'
  },
  {
    value: 'father_photo_uploaded',
    fieldMatchWithColumn: 'Father Photo Uploaded?',
    label: 'Father Photo Uploaded?'
  },
  {
    value: 'father__mobile_no',
    fieldMatchWithColumn: 'personalDetails.contactNo',
    label: 'Father Contact No'
  },
  {
    value: 'father__profile',
    fieldMatchWithColumn: 'profile',
    label: 'Father Photo'
  },
  {
    value: 'father__email_id',
    fieldMatchWithColumn: 'email',
    label: 'Father Email'
  },
  {
    value: 'father__aadhar_card_no',
    fieldMatchWithColumn: 'officialDetails.adhaarCardNo',
    label: 'Father Adhaar Card No'
  },
  {
    value: 'father__pan_card_no',
    fieldMatchWithColumn: 'panCardNo',
    label: 'Father Pancard No'
  },
  {
    value: 'father__educational_qualifications',
    fieldMatchWithColumn: 'educationalQualification',
    label: 'Father Educational Qualification'
  },
  {
    value: 'father__profession',
    fieldMatchWithColumn: 'occupationDetails.profession',
    label: 'Father Profession'
  },
  {
    value: 'father__name_of_organisation',
    fieldMatchWithColumn: 'occupationDetails.organizationName',
    label: 'Father Organization Name'
  },
  {
    value: 'father__designation',
    fieldMatchWithColumn: 'occupationDetails.designation',
    label: 'Father Designation'
  },
  {
    value: 'father__office_contact_no',
    fieldMatchWithColumn: 'occupationDetails.officeContactNo',
    label: 'Father Office Contact No'
  },
  {
    value: 'father__office_address',
    fieldMatchWithColumn: 'occupationDetails.officeAddress',
    label: 'Father Office Address'
  },
  {
    value: 'father__website_or_linkedin_profile',
    fieldMatchWithColumn: 'occupationDetails.websiteOrLinkedInProfileUrl',
    label: 'Father Website'
  },
  {
    value: 'father__annual_income',
    fieldMatchWithColumn: 'occupationDetails.annualIncome',
    label: 'Father Annual Income'
  },
  {
    value: 'father_is_govt_employee',
    fieldMatchWithColumn: 'occupationDetails.isGovermentEmployee',
    label: 'Father is Govt Employee?'
  },
  {
    value: 'father__name_of_department',
    fieldMatchWithColumn: 'occupationDetails.department',
    label: 'Father Govt Department Name'
  }
];

const AllColumnsMappingOptions: ColumnMappingOption[] = [
  ...StudentProfileColumnsOptions,
  ...MotherColumnsOptions,
  ...FatherColumnsOptions
];

const StudentActionItems: {
  key: string;
  label: string;
  onClick?: () => void;
}[] = [
  { key: 'request_lc', label: 'Request LC' },
  { key: 'generate_lc', label: 'Generate LC' },
  // { key: 'generate_bonafide', label: 'Generate Bonafide' },
  { key: 'deactivate_student', label: 'De-Activate Student' },
  { key: 'activate_student', label: 'Activate Student' },
  { key: 'accept_lc', label: 'Accept LC Request' },
  { key: 'reject_lc', label: 'Reject LC Request' }
];

const TabConfigOptions: TabConfig[] = [
  {
    id: 'student_information',
    label: 'Student Information',
    selectedIcon: Icons.UserFilled,
    unselectedIcon: Icons.UserFilledBlack
  },
  {
    id: 'family_information',
    label: 'Family Information',
    selectedIcon: Icons.FamilyWhite,
    unselectedIcon: Icons.FamilyBlack
  }
];

const FamilyTabOptions: {
  id: familyTabTypes;
  label: string;
  selectedIcon?: React.ComponentType<any>;
  unselectedIcon?: React.ComponentType<any>;
}[] = [
  {
    id: 'motherDetails',
    label: 'Mother',
    selectedIcon: Icons.FemalePurple,
    unselectedIcon: Icons.FemaleBlack
  },
  {
    id: 'fatherDetails',
    label: 'Father',
    selectedIcon: Icons.MalePurple,
    unselectedIcon: Icons.MaleBlack
  },

  {
    id: 'guardianDetails',
    label: 'Guardian',
    selectedIcon: Icons.ParentPurple,
    unselectedIcon: Icons.ParentBlack
  },
  {
    id: 'siblingDetails',
    label: 'Sibling',
    selectedIcon: Icons.SiblingPurple,
    unselectedIcon: Icons.SiblingBlack
  }
];

const StudentTabOptions: {
  id: studentTabTypes;
  label: string;
  selectedIcon?: React.ComponentType<any>;
  unselectedIcon?: React.ComponentType<any>;
}[] = [
  {
    id: 'studentProfile',
    label: 'Student Profile',
    selectedIcon: Icons.StudentProfileFilled,
    unselectedIcon: Icons.StudentProfileBlackFilled
  },
  {
    id: 'studentAcademicInfo',
    label: 'Academic Info',
    selectedIcon: Icons.AcademicInfoFilled,
    unselectedIcon: Icons.AcademicInfoBlackFilled
  },

  {
    id: 'studentDemographicInfo',
    label: 'Demographic Info',
    selectedIcon: Icons.DemographicInfoFilled,
    unselectedIcon: Icons.DemographicInfoBlackFilled
  },
  {
    id: 'studentHealthInfo',
    label: 'Health Info',
    selectedIcon: Icons.HealthInfoFilled,
    unselectedIcon: Icons.HealthInfoBlackFilled
  }
];

const progressOptions = [
  { label: 'Excellent', value: 'Excellent' },
  { label: 'Very Good', value: 'Very Good' },
  { label: 'Good', value: 'Good' },
  { label: 'Fair', value: 'Fair' }
];

const generalConductOptions = [
  { label: 'Excellent', value: 'Excellent' },
  { label: 'Very Good', value: 'Very Good' },
  { label: 'Good', value: 'Good' },
  { label: 'Fair', value: 'Fair' }
];

const reasonOfLeavingOptions = [
  { value: 'OTHER', label: 'Other' },
  {
    label: 'Moving to another city/ country',
    value: 'Moving to another city/ country'
  },
  { label: 'School academics', value: 'School academics' },
  { label: 'School infrastructure', value: 'School infrastructure' },
  { label: 'Financial issues', value: 'Financial issues' },
  { label: 'Overall school experience', value: 'Overall school experience' },
  {
    label: 'Moving to another location within the city',
    value: 'Moving to another location within the city'
  }
];

const ConfirmationDialogMessages: Record<string, string> = {
  reject_lc: 'Are you sure you want to reject this LC request?',
  accept_lc: 'Are you sure you want to accept this LC request?',
  generate_bonafide: 'Are you sure you want to generate Bonafide?',
  activate_student: 'Are you sure you want to activate this student?',
  deactivate_student: 'Are you sure you want to deactivate this student?',
  request_lc: 'Are you sure you want to request LC?',
  default: 'Are you sure you want to perform this action?'
};

export {
  AllColumnsMappingOptions,
  StudentProfileColumnsOptions,
  FatherColumnsOptions,
  MotherColumnsOptions,
  StudentActionItems,
  ConfirmationDialogMessages,
  TabConfigOptions,
  FamilyTabOptions,
  progressOptions,
  generalConductOptions,
  reasonOfLeavingOptions,
  StudentTabOptions
};
